/* src/app/components/lead-details/documents/documents/documents.component.css */
.document-history-wrapper {
  position: relative;
  width: 100%;
}
.document-history-action {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
}
/*# sourceMappingURL=documents.component-FKDMFHOO.css.map */
